module.exports = vendor_7ce7f9a9f2dacdb2841a;